export const removeParameter = (currentPath: string, parameter: string) => {
    const REGEX_QUESTION_AMPERSAND = new RegExp(
        `\\?${parameter}=[0-9a-zA-Z]+&`
    );
    if (REGEX_QUESTION_AMPERSAND.test(currentPath))
        return currentPath.replace(REGEX_QUESTION_AMPERSAND, '?');

    const QUESTION_ONLY = new RegExp(`\\?${parameter}=[0-9a-zA-Z]+`, 'g');
    if (QUESTION_ONLY.test(currentPath))
        return currentPath.replace(QUESTION_ONLY, '');

    const REGEX_AMPERSAND = new RegExp(`&${parameter}=[0-9a-zA-Z]+`, 'g');
    if (REGEX_AMPERSAND.test(currentPath))
        return currentPath.replace(REGEX_AMPERSAND, '');

    return currentPath;
};

export const removePageSpecificParams = (currentPath: string) => {
    const removedPageSize = removeParameter(currentPath, 'page_size');
    const removedViewType = removeParameter(removedPageSize, 'view_type');
    return removedViewType;
};
